import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BrokerFacade } from "../../../../broker/domain/+state/broker.facade";
import { BrokerDataDetails, BrokerUserData } from "../../../../broker/domain/models/broker.model";

@Injectable({
  providedIn: "root",
})
export class DashboardBridgeService {
  constructor(
    private readonly brokerFacade: BrokerFacade
  ) { }

  getCurrentBroker$(): Observable<BrokerUserData> {
    return this.brokerFacade.getCurrentBroker$().pipe();
  }

  getBrokerDataDetails$(): Observable<BrokerDataDetails> {
    return this.brokerFacade.getBrokerDataDetails$().pipe();
  }
}
